import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET cos-doimains/v1/permitted-domains/for-blog-settings
 */
export function fetchDomainsForBlogSettings(query, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('cos-domains/v1/permitted-domains/for-blog-settings', {
    query
  });
}